import { StateHandler } from "../util/getStateFun";
import { startLoader, stopLoader } from "../util/loader";
import { NearbyLocations } from "../util/nearbyLocations";
import { checkDomain, getFranchiseDetails, getBrandDetailsFromBrandJson } from "../util/share";
import { FindUsAddressBumper } from "./FindUsAddressBumper";
import { REGEX } from "../constants/regex";
import { updateServiceHeadingUtil } from "../util/findusmodal-verbiage";
import { UseMyLocationSearch } from "../header/useMyLocation";

export class FindUsModal {

    private static instance: FindUsModal;
    private readonly zipInput: HTMLInputElement | null;
    private readonly submitBtn: HTMLElement | null;
    private readonly step5: HTMLElement | null;
    private readonly happyText: HTMLElement | null;
    private readonly steps: any;
    static getInstance(): FindUsModal {
        if (!FindUsModal.instance) {
            FindUsModal.instance = new FindUsModal();
        }
        return FindUsModal.instance;
    }
    private constructor() {
        // Get elements
        this.zipInput = document.getElementById("dynamic-local-search-modal") as HTMLInputElement;
        this.submitBtn = document.querySelector(".dynamic-find-local-modal .dynamic-step-1 .form-cta .primary-btn");
        this.step5 = document.querySelector(".dynamic-step-5");
        this.steps = {
            step1: document.querySelector(".dynamic-step-1"),
            step2: document.querySelector(".dynamic-step-2"),
            step3: document.querySelector(".dynamic-step-3"),
            step4: document.querySelector(".dynamic-step-4"),
            step5: document.querySelector(".dynamic-step-5"),
        };
        this.happyText = document.querySelector(".dynamic-step-5 .happy-text");

        if (this.submitBtn) {
            this.submitBtn.addEventListener("click", () => this.handleSubmit());
        }
        if (this.zipInput) {
            this.zipInput?.addEventListener("input", this.zipCodeError.bind(this));
        }
        const closeButton = document.getElementById("dynamic-close-local-modal");
        closeButton?.addEventListener("click", () => {
            // Select all dynamic step elements
            const steps = document.querySelectorAll(".dynamic-step-2, .dynamic-step-3, .dynamic-step-4, .dynamic-step-5");
            steps.forEach(step => step.classList.add("hidden")); // Hide all steps

            // Show only dynamic-step-1
            const step1 = document.querySelector(".dynamic-step-1");
            if (step1) {
                const step1Text1 = document.getElementById("dynamic-step1-text1") as HTMLElement;
                const step1Text2 = document.getElementById("dynamic-step1-text2") as HTMLElement;

                // Hide step1-text1
                if (step1Text1) step1Text1.style.display = "block";

                // Show step1-text2
                if (step1Text2) step1Text2.style.display = "none";
                step1.classList.remove("hidden");
                // Clear the zip input field
                if (this.zipInput) {
                    this.zipInput.value = "";
                }
            }
        });
        const useMyLocationBtn = document.querySelectorAll('.dynamic-find-local-modal .use-my-location-btn');
        if (useMyLocationBtn && useMyLocationBtn?.length > 0) {
            useMyLocationBtn?.forEach((btn) => {
                btn?.addEventListener('click', (e) => {
                    e.preventDefault(); // Prevent form submission
                    new UseMyLocationSearch().getCurrentLocation(e);
                });
            });
        }
    }

    zipCodeError() {
        if (!this.zipInput) return;
        const isCaDomainCheck = checkDomain() === 'ca' ?
            !REGEX.caSendZip.test(this.zipInput.value.trim()) :
            !REGEX.sendZip.test(this.zipInput.value.trim());
        const fieldError: any = document.querySelector('.dynamic-find-local-modal .error-msg');

        if (this.zipInput?.value !== '' && isCaDomainCheck) {
            fieldError?.classList.remove('hidden')
            !fieldError.innerHTML.trim() && (fieldError.innerHTML = 'Invalid zip code format.')
        } else {
            fieldError?.classList.add('hidden')
        }
    }

    private callNearbyLocations(units: string, franchiseLimit: number, zipCode: string) {
        new NearbyLocations(units, franchiseLimit).searchNearbyLocations(zipCode)
            .then(this.displayNearbyLocations.bind(this))
            .catch(() => this.handleErrorScenario(zipCode));
    }

    private async fetchPhoneFromBrandData(): Promise<string | undefined> {
        const conceptCode = (document.getElementById('conceptCode') as HTMLInputElement)?.value;
        if (!conceptCode) {
            return Promise.reject(new Error("Concept code is missing"));
        }
        try {
            const brandData = await getBrandDetailsFromBrandJson(conceptCode);
            return brandData?.phone;
        } catch (error) {
            console.error("Error fetching brand details:", error);
            return Promise.reject(error instanceof Error ? error : new Error(String(error)));
        }
    }
    private extractPhoneNumber(firstLoc: any): string | undefined {
        let phone: string | undefined;
        if (Array.isArray(firstLoc.websiteTrackingPhone) && firstLoc.websiteTrackingPhone?.length > 0) {
            phone = firstLoc.websiteTrackingPhone[0]; // Use the first phone number from the array
        } else if (typeof firstLoc.websiteTracking === "string") {
            phone = firstLoc.websiteTracking; // Use the single phone number
        }
        // Fallback to `phoneNumber` if neither is available
        return phone ?? firstLoc.phoneNumber;
    }
    private async displayNearbyLocations(data: any) {
        if (!data.length) return this.handleErrorScenario(data);

        Object.values(this.steps).forEach(step => (step as HTMLElement)?.classList.add("hidden"));
        // Handle dynamic-step-5 updates
        const firstLocation = data[0];
        if (firstLocation) {
            const step5 = document.querySelector(".dynamic-step-5");
            step5?.classList.remove("hidden");

            const notFoundWrapper = this.steps.step5.querySelector(".loc-not-found-wrapper");
            notFoundWrapper?.classList.remove("hidden");
            // Update ZIP code inside loc-not-found-wrapper
            const notFoundZipSpan =  this.steps.step5.querySelector(".loc-not-found-wrapper p span");
            if (notFoundZipSpan && this.zipInput) {
                notFoundZipSpan.textContent = this.zipInput?.value.trim();
            }
            this.steps.step5.querySelector(".not-found-text")?.classList.remove("hidden");
            this.steps.step5.querySelector(".happy-text")?.classList.add("hidden");

            this.steps.step5.querySelector(".heading-container h3")!.textContent = firstLocation.doingBusinessAs;
            this.steps.step5.querySelector(".view-web-link")!.setAttribute("href", firstLocation.websiteUrl);
            let phone: string | undefined;
            phone = this.extractPhoneNumber(firstLocation);
            phone ??= await this.fetchPhoneFromBrandData();

            if (phone) {
                const formattedPhone = phone.replace(/\D/g, "");
                const displayPhone = `(${formattedPhone.slice(0, 3)}) ${formattedPhone.slice(3, 6)}-${formattedPhone.slice(6)}`;
                this.steps.step5.querySelector(".phone-num-wrapper")!.setAttribute("href", `tel:${formattedPhone}`);
                this.steps.step5.querySelector(".phone-num-wrapper")!.innerHTML = `
                    <svg aria-hidden="true" class="h-6 w-6">
                        <use xlink:href="/_assets-global/images/hero-icon-sprite.svg#phone-outline-primary"></use>
                    </svg>
                    ${displayPhone}`;
            }
        }
    }

    private handleSubmit() {
        if (!this.zipInput) return;
        const zipCode = this.zipInput?.value.trim();
         const modal = document.getElementById('dynamic-glb-find-local');
        const serviceIdValue = modal?.getAttribute('data-service-id')?.trim();
        if (this.validateForm()) {
            startLoader();
            this.getData(zipCode, serviceIdValue);
        }
    }
    getData(zipCode: string, serviceIdValue?: string) {
         const franchiseDetailsPromise = serviceIdValue
            ? getFranchiseDetails(zipCode, false, serviceIdValue)
            : getFranchiseDetails(zipCode, false);
        franchiseDetailsPromise
            .then(async (response) => {
                const result = response;
                if (response.length === 0) {
                    this.handleNoResults();
                    return;
                }
                if (!this.happyText) { return };
                const steps = document.querySelectorAll(".dynamic-step-1, .dynamic-step-2, .dynamic-step-3, .dynamic-step-4");
                steps?.forEach(step => step.classList.add("hidden")); // Hide all steps
                this.step5?.classList.remove("hidden");
                const zipCodeSpan = document.querySelector(".dynamic-step-5 .happy-text span") as HTMLElement;
                if (zipCodeSpan && this.zipInput) {
                    stopLoader();
                    zipCodeSpan.textContent = this.zipInput.value.trim(); // Replace with actual ZIP code
                    this.steps.step5.querySelector(".not-found-text")?.classList.add("hidden");
                    this.steps.step5.querySelector(".loc-not-found-wrapper")?.classList.add("hidden");
                    this.steps.step5.querySelector(".happy-text")?.classList.remove("hidden");
            
                }
                const heading = document.querySelector('.dynamic-step-5 .heading-container h3') as HTMLElement;
                const phoneWrapper = document.querySelector('.dynamic-step-5 .phone-num-wrapper') as HTMLAnchorElement;
                const websiteLink = document.querySelector('.dynamic-step-5 .view-web-link') as HTMLAnchorElement;

                let phone: string | undefined;
                let firstLoc = result[0];
                phone = this.extractPhoneNumber(firstLoc);
                phone ??= await this.fetchPhoneFromBrandData();
               
                // Format phone number for `tel:` link
                if (phone) {
                    const formattedPhone = phone.replace(/\D/g, "");
                    const phoneFormat: any = phone
                        ? `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6)}`
                        : null;
                    // Update content if elements exist
                    if (heading) heading.textContent = result[0].doingBusinessAs;
                    if (phoneWrapper) {
                        phoneWrapper.href = `tel:${formattedPhone}`;
                        phoneWrapper.innerHTML = `
                <svg aria-hidden="true" class="h-6 w-6">
                    <use xlink:href="/_assets-global/images/hero-icon-sprite.svg#phone-outline-primary"></use>
                </svg>
                ${phoneFormat}
            `;
                    }
                }
                if (websiteLink) {
                    websiteLink.href = result[0].locationWebsiteUrl;
                }

               FindUsModal.getInstance().updateServiceHeading();
            })
            .catch(async (err) => {
                stopLoader();
                if (typeof err?.then === 'function') {
                    err = await err;
                    }
                    
                    let message = err?.response?.data?.message;
                    if(!message){
                        message = err?.message;
                    } 
                    if(!message){
                        message = '';
                    }
                   
                if (message.toLowerCase() === "full address is needed to narrow down results") {
                    const stateHandler = new StateHandler();
                    stateHandler.getStateFun();
                    const step1 = document.querySelector('.dynamic-step-1') as HTMLElement;
                    const step2 = document.querySelector('.dynamic-step-2') as HTMLElement;

                    if (step1) {
                        step1.classList.add('hidden');
                    }

                    if (step2) {
                        step2.classList.remove('hidden');
                        const closeLocalModal = document.querySelector('.close-modal-btn');
                        closeLocalModal?.addEventListener('click', function handleClick(event) {

                            step2.classList.add("hidden");
                            step1.classList.remove("hidden");
                        })
                    }
                    const modalZipCode = document.querySelector('.dynamic-step-2 #dynamic-modal-zipcode') as HTMLInputElement;
                    modalZipCode.value = encodeURIComponent(zipCode);

                    const locateAddressBumper = new FindUsAddressBumper();
                }
                else {
                    this.handleErrorScenario(zipCode);
                }
            });
    }

    handleNoResults() {
        const zipCode = this.zipInput?.value.trim();
        if (zipCode) this.handleNearbyLocationsFlow(zipCode);
        stopLoader();
    }

    private handleNearbyLocationsFlow(inputArg: any) {
        let franchiseLimit: number, units: string, nearbyLocations;
        let flag = true;
        if (flag) {
            units = "50miles";
            franchiseLimit = 50;
            this.callNearbyLocations(units, franchiseLimit, inputArg);
        }
        else {
            this.handleErrorScenario(inputArg);
        }

    }

    private handleErrorScenario(zipCode: string) {
        const step1Text1 = document.getElementById("dynamic-step1-text1") as HTMLElement;
        const step1Text2 = document.getElementById("dynamic-step1-text2") as HTMLElement;

        // Hide step1-text1
        if (step1Text1) step1Text1.style.display = "none";

        // Show step1-text2
        if (step1Text2) step1Text2.style.display = "block";

    }

    validateForm(): boolean {
        const zipCodeInput = document.getElementById("dynamic-local-search-modal") as HTMLInputElement;
        const fieldError = document.querySelector('.dynamic-find-local-modal .error-msg') as HTMLElement;

        if (!zipCodeInput || !fieldError) return false; // Ensure elements exist

        const zipCode = zipCodeInput.value.trim();

        // Reset error visibility
        fieldError.classList.add("hidden");
        zipCodeInput.classList.remove("invalid-field");

        // Check if ZIP code is required and empty
        if (zipCodeInput.required && !zipCode) {
            fieldError.classList.remove("hidden");
            zipCodeInput.classList.add("invalid-field");
            zipCodeInput.focus();
            return false;
        }

        // Validate ZIP code format
        if (!REGEX.sendZip.test(zipCode)) {
            fieldError.classList.remove("hidden");
            zipCodeInput.classList.add("invalid-field");
            zipCodeInput.focus();
            return false;
        }

        return true;
    }

    public updateServiceHeading() {
        const modal = document.getElementById('dynamic-glb-find-local');
        if (!modal) return;
        const happyTextSelector = document.querySelector('#dynamic-glb-find-local .dynamic-step-5 .happy-text');
        const happyText = happyTextSelector instanceof HTMLElement ? happyTextSelector : null;

        const notFoundTextSelector = document.querySelector('#dynamic-glb-find-local .dynamic-step-5 .loc-not-found-wrapper p');
        const notFoundText = notFoundTextSelector instanceof HTMLElement ? notFoundTextSelector : null;

        updateServiceHeadingUtil({
            modal,
            happyText,
            notFoundText,
        });
       
    }
}


document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.section-50-50');
    const dbaName: string | null = localStorage.getItem('dbaName');
    const webId: string | null = localStorage.getItem('weblocationId');
    // Process each section
    sections?.forEach(section => {
        if (!section) return; 
        // Check if section is inside hero-banner
        const isInHeroBanner = !!section.closest('.hero-banner');        
        const findLocLink = section.querySelector('.find-loc-link') as HTMLElement;
        const findLocWrapper = section.querySelector('.find-a-loc-wrapper, .accommodate-text') as HTMLElement;
          // Hide wrapper if section is NOT in hero-banner and meets hiding conditions
        const hasRequiredProps = findLocLink && webId && dbaName;
        const shouldHideInDba = hasRequiredProps && window.location.href.includes(dbaName);
        const shouldHideOutsideDba = hasRequiredProps && !window.location.href.includes(dbaName);
        
        if (!isInHeroBanner && (shouldHideInDba || shouldHideOutsideDba)) {
            if (findLocWrapper instanceof HTMLElement) {
                // Hide the find-a-loc-wrapper which has link
                findLocWrapper.style.display = 'none';
            }
        } else if (findLocLink) {
            // Attach click handler to store heading text
            findLocLink.addEventListener('click', function () {
                const section = findLocLink.closest('.section-50-50');
                const heading = section?.querySelector('.find-a-loc-wrapper p span:first-child, .accommodate-text p span:first-child') as HTMLElement;
                const modal = document.getElementById('dynamic-glb-find-local');
                let serviceIdValue: string | undefined;

                // Check if hidden input exists and has a non-empty value
                 const hiddenInput = section?.querySelector('.accommodate-text input[type="hidden"], .find-a-loc-wrapper input[type="hidden"]') as HTMLInputElement;
                if (hiddenInput?.value?.trim()) {
                    serviceIdValue = hiddenInput.value.trim();
                }
                if (heading && modal) {
                    modal.setAttribute('data-service-heading', heading.textContent?.trim() ?? 'Electrical Services');
                // Pass serviceIdValue to modal via a custom attribute
                    modal.setAttribute('data-service-id', serviceIdValue ?? '');
                }
                // update modal content here
                FindUsModal.getInstance().updateServiceHeading();
               
            });
            FindUsModal.getInstance();
        }
    });
});